export const smoothScroll = (ref) => {
    if (ref.current) ref.current.scrollIntoView({ behavior: 'smooth' });
};
